<form [formGroup]="doador">
  <div class="row">
    <div class="col-sm d-flex justify-content-start">
      <h3 class="mt-3">Informações Pessoais</h3>
    </div>
    <div class="col-sm d-flex justify-content-end">
      <button
        *ngIf="!finalizarCliente; else textoFinalizado"
        style="margin: 10px"
        type="button"
        mat-flat-button
        color="warn"
        (click)="finalizarContrato()"
        [disabled]="!contratoValido || finalizarCliente || !desabilitarBotoes"
      >
        <span>Finalizar Cliente</span>
      </button>
      <ng-template #textoFinalizado>
        <div
          style="
            text-align: right;
            color: red;
            font-style: italic;
            margin-top: 1.3em;
            margin-right: 1em;
          "
        >
          *Formulário do cliente finalizado
        </div></ng-template
      >
    </div>
  </div>
  <p style="font-size: small">
    <i>Os campos marcados em vermelho são de preenchimento obrigatório.</i>
  </p>
  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>CPF</mat-label>
        <input
          matInput
          placeholder="CPF"
          formControlName="cpf"
          mask="000.000.000-00"
          id="cpf"
          (blur)="consultaCPF()"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Nome</mat-label>
        <input matInput placeholder="Nome" formControlName="nome" id="nome" />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>RG</mat-label>
        <input
          type="text"
          matInput
          placeholder="RG"
          formControlName="rg"
          id="rg"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm" mt-3>
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Sexo</mat-label>
        <mat-select formControlName="sexo" id="sexo">
          <mat-option value="Masculino">Masculino</mat-option>
          <mat-option value="Feminino">Feminino</mat-option>
          <mat-option value="Outro">Outro</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Estado Civil</mat-label>
        <mat-select formControlName="estadoCivil" id="estadoCivil">
          <mat-option value="Solteiro(a)">Solteiro(a)</mat-option>
          <mat-option value="Casado(a)">Casado(a)</mat-option>
          <mat-option value="Separado(a)">Separado(a)</mat-option>
          <mat-option value="Divorciado(a)">Divorciado(a)</mat-option>
          <mat-option value="Viuvo(a)">Viúvo(a)</mat-option>
          <mat-option value="Outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Nacionalidade</mat-label>
        <input
          matInput
          placeholder="Nacionalidade"
          formControlName="nacionalidade"
          id="nacionalidade"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          rInputMask="99/99/9999"
          placeholder="dd/mm/aaaa"
          formControlName="dataNascimento"
          id="dataNascimento"
          (blur)="checkIdade()"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Profissão</mat-label>
        <input
          matInput
          placeholder="Profissão"
          formControlName="profissao"
          id="profissao"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          placeholder="Email"
          formControlName="email"
          id="email"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Tipagem Sanguínea</mat-label>
        <mat-select formControlName="tipagemSanguinea">
          <mat-option value="A">A</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="O">O</mat-option>
          <mat-option value="AB">AB</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>RH</mat-label>
        <mat-select formControlName="rh">
          <mat-option value="Positivo">Positivo</mat-option>
          <mat-option value="Negativo">Negativo</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <h5 class="mt-5" style="color: #808080">Endereço Residencial</h5>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>CEP</mat-label>
        <input
          type="text"
          matInput
          placeholder="CEP"
          formControlName="cep"
          id="cep"
          (blur)="consultaCep()"
          mask="00.000-000"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Logradouro</mat-label>
        <input
          type="text"
          matInput
          placeholder="Logradouro"
          formControlName="endereco"
          id="endereco"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Número</mat-label>
        <input
          type="text"
          matInput
          placeholder="Número"
          formControlName="numEndereco"
          id="numEndereco"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Complemento</mat-label>
        <input
          type="text"
          matInput
          placeholder="Complemento"
          formControlName="complemento"
          id="omplemento"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Bairro</mat-label>
        <input
          type="text"
          matInput
          placeholder="Bairro"
          formControlName="bairro"
          id="bairro"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Cidade</mat-label>
        <input
          type="text"
          matInput
          placeholder="Cidade"
          formControlName="cidade"
          id="cidade"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Estado</mat-label>
        <input
          type="text"
          matInput
          placeholder="Estado"
          formControlName="estado"
          id="estado"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone</mat-label>
        <input
          type="text"
          matInput
          placeholder="Telefone"
          formControlName="telefone"
          id="telefone"
          mask="(00)0000-0000"
        />
      </mat-form-field>
    </div>
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone Celular</mat-label>
        <input
          type="text"
          matInput
          placeholder="Tel. Celular"
          formControlName="telefoneCelular"
          id="telefoneCelular"
          mask="(00)00000-0000"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone Comercial</mat-label>
        <input
          type="text"
          matInput
          placeholder="Tel. Comercial"
          formControlName="telefoneComercial"
          id="telefoneComercial"
          mask="(00)0000-0000"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Observações</mat-label>
        <input
          matInput
          placeholder="Observações"
          formControlName="observacoes"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Valor do Contrato</mat-label>
        <!-- <input matInput placeholder="Taxa do Contrato" formControlName="taxaContrato" type="number"> -->

        <input
          matInput
          placeholder="0,00"
          type="text"
          formControlName="taxaContrato"
          currencyMask
          [options]="{
            prefix: 'R$ ',
            thousands: '.',
            decimal: ',',
            align: 'left',
            allowNegative: false
          }"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngIf="maiorDeIdade">
    <div class="col-sm">
      <mat-checkbox [checked]="true" disabled
        >Informações acima utilizadas para Responsável e
        Beneficiário</mat-checkbox
      ><br />
    </div>
  </div>
</form>

<form [formGroup]="captacao" *ngIf="!maiorDeIdade" class="mb-5">
  <h3 class="mt-5">Responsável 1</h3>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>CPF</mat-label>
        <input
          matInput
          placeholder="CPF"
          formControlName="cpfResponsavel1"
          mask="000.000.000-00"
          id="cpfResponsavel1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Nome do responsável</mat-label>
        <input
          matInput
          placeholder="Nome do responsável"
          formControlName="nomeResponsavel1"
          id="nomeResponsavel1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>RG</mat-label>
        <input
          type="text"
          matInput
          placeholder="RG"
          formControlName="rgResponsavel1"
          id="rgResponsavel1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          rInputMask="99/99/9999"
          placeholder="dd/mm/aaaa"
          formControlName="dataNascimentoResponsavel1"
          id="dataNascimentoResponsavel1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Estado Civil</mat-label>
        <mat-select formControlName="estadoCivilResp1" id="estadoCivilResp1">
          <mat-option value="Solteiro(a)">Solteiro(a)</mat-option>
          <mat-option value="Casado(a)">Casado(a)</mat-option>
          <mat-option value="Separado(a)">Separado(a)</mat-option>
          <mat-option value="Divorciado(a)">Divorciado(a)</mat-option>
          <mat-option value="Viuvo(a)">Viúvo(a)</mat-option>
          <mat-option value="Outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Nacionalidade</mat-label>
        <input
          matInput
          placeholder="Nacionalidade"
          formControlName="nacionalidadeResp1"
          id="nacionalidadeResp1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Profissão</mat-label>
        <input
          matInput
          placeholder="Profissão"
          formControlName="profissaoResp1"
          id="profissaoResp1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Grau de parentesco</mat-label>
        <mat-select
          formControlName="grauParentescoResp1"
          id="grauParentescoResp1"
        >
          <mat-option value="Mae">Mãe</mat-option>
          <mat-option value="Pai">Pai</mat-option>
          <mat-option value="Avo1">Avó</mat-option>
          <mat-option value="Avo2">Avô</mat-option>
          <mat-option value="Tia">Tia</mat-option>
          <mat-option value="Tio">Tio</mat-option>
          <mat-option value="Irma">Irmã</mat-option>
          <mat-option value="Irmao">Irmão</mat-option>
          <mat-option value="Outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          placeholder="Email"
          formControlName="emailResponsavel1"
          id="emailResponsavel1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>CEP</mat-label>
        <input
          type="text"
          matInput
          placeholder="CEP"
          formControlName="cepResponsavel1"
          id="cepResponsavel1"
          (blur)="consultaCepResponsavel1()"
          mask="00.000-000"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Logradouro</mat-label>
        <input
          type="text"
          matInput
          placeholder="Logradouro"
          formControlName="enderecoResponsavel1"
          id="enderecoResponsavel1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Número</mat-label>
        <input
          type="text"
          matInput
          placeholder="Número"
          formControlName="numEnderecoResponsavel1"
          id="numEnderecoResponsavel1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Complemento</mat-label>
        <input
          type="text"
          matInput
          placeholder="Complemento"
          formControlName="complementoResponsavel1"
          id="complementoResponsavel1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Bairro</mat-label>
        <input
          type="text"
          matInput
          placeholder="Bairro"
          formControlName="bairroResponsavel1"
          id="bairroResponsavel1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Cidade</mat-label>
        <input
          type="text"
          matInput
          placeholder="Cidade"
          formControlName="cidadeResponsavel1"
          id="cidadeResponsavel1"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Estado</mat-label>
        <input
          type="text"
          matInput
          placeholder="Estado"
          formControlName="estadoResponsavel1"
          id="estadoResponsavel1"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone</mat-label>
        <input
          type="text"
          matInput
          placeholder="Telefone"
          formControlName="telefoneResponsavel1"
          id="telefoneResponsavel1"
          mask="(00)0000-0000"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone Celular</mat-label>
        <input
          type="text"
          matInput
          placeholder="Tel. Celular"
          formControlName="telefoneCelularResponsavel1"
          id="telefoneCelularResponsavel1"
          mask="(00)00000-0000"
        />
      </mat-form-field>
    </div>
  </div>

  <h3 class="mt-5">Responsável 2</h3>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>CPF</mat-label>
        <input
          matInput
          placeholder="CPF"
          formControlName="cpfResponsavel2"
          mask="000.000.000-00"
          id="cpfResponsavel2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Nome do responsável</mat-label>
        <input
          matInput
          placeholder="Nome do responsável"
          formControlName="nomeResponsavel2"
          id="nomeResponsavel2"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>RG</mat-label>
        <input
          type="text"
          matInput
          placeholder="RG"
          formControlName="rgResponsavel2"
          id="rgResponsavel2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          rInputMask="99/99/9999"
          placeholder="dd/mm/aaaa"
          formControlName="dataNascimentoResponsavel2"
          id="dataNascimentoResponsavel2"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Estado Civil</mat-label>
        <mat-select formControlName="estadoCivilResp2" id="estadoCivilResp2">
          <mat-option value="Solteiro(a)">Solteiro</mat-option>
          <mat-option value="Casado(a)">Casado</mat-option>
          <mat-option value="Separado(a)">Separado</mat-option>
          <mat-option value="Divorciado(a)">Divorciado</mat-option>
          <mat-option value="Viuvo(a)">Viúvo</mat-option>
          <mat-option value="Outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Nacionalidade</mat-label>
        <input
          matInput
          placeholder="Nacionalidade"
          formControlName="nacionalidadeResp2"
          id="nacionalidadeResp2"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Profissão</mat-label>
        <input
          matInput
          placeholder="Profissão"
          formControlName="profissaoResp2"
          id="profissaoResp2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Grau de parentesco</mat-label>
        <mat-select
          formControlName="grauParentescoResp2"
          id="grauParentescoResp2"
        >
          <mat-option value="Mae">Mãe</mat-option>
          <mat-option value="Pai">Pai</mat-option>
          <mat-option value="Avo1">Avó</mat-option>
          <mat-option value="Avo2">Avô</mat-option>
          <mat-option value="Tia">Tia</mat-option>
          <mat-option value="Tio">Tio</mat-option>
          <mat-option value="Irma">Irmã</mat-option>
          <mat-option value="Irmao">Irmão</mat-option>
          <mat-option value="Outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          placeholder="Email"
          formControlName="emailResponsavel2"
          id="emailResponsavel2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>CEP</mat-label>
        <input
          type="text"
          matInput
          placeholder="CEP"
          formControlName="cepResponsavel2"
          id="cepResponsavel2"
          (blur)="consultaCepResponsavel2()"
          mask="00.000-000"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Logradouro</mat-label>
        <input
          type="text"
          matInput
          placeholder="Logradouro"
          formControlName="enderecoResponsavel2"
          id="enderecoResponsavel2"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Número</mat-label>
        <input
          type="text"
          matInput
          placeholder="Número"
          formControlName="numEnderecoResponsavel2"
          id="numEnderecoResponsavel2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Complemento</mat-label>
        <input
          type="text"
          matInput
          placeholder="Complemento"
          formControlName="complementoResponsavel2"
          id="complementoResponsavel2"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Bairro</mat-label>
        <input
          type="text"
          matInput
          placeholder="Bairro"
          formControlName="bairroResponsavel2"
          id="bairroResponsavel2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Cidade</mat-label>
        <input
          type="text"
          matInput
          placeholder="Cidade"
          formControlName="cidadeResponsavel2"
          id="cidadeResponsavel2"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Estado</mat-label>
        <input
          type="text"
          matInput
          placeholder="Estado"
          formControlName="estadoResponsavel2"
          id="estadoResponsavel2"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone</mat-label>
        <input
          type="text"
          matInput
          placeholder="Telefone"
          formControlName="telefoneResponsavel2"
          id="telefoneResponsavel2"
          mask="(00)0000-0000"
        />
      </mat-form-field>
    </div>

    <div class="col-sm">
      <mat-form-field appearance="standard" class="input-full-width">
        <mat-label>Telefone Celular</mat-label>
        <input
          type="text"
          matInput
          placeholder="Tel. Celular"
          formControlName="telefoneCelularResponsavel2"
          id="telefoneCelularResponsavel2"
          mask="(00)00000-0000"
        />
      </mat-form-field>
    </div>
  </div>
</form>

